import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { AdOrderContext } from '../../contexts/AdOrder'
import Label from './Label'
import useInput from '../../hooks/useInput'

export default function TextareaInput ({
  name, context, label, placeholder, required = false, type = 'text', size, resize = 'none'
}) {

  const { getValue, setValue } = useInput(context)

  const handleOnChange = function (e) {
    setValue(name, e.target.value)
  }

  const wrapClassNames = classNames('input-wrap', {
    'input-wrap--half': size === 'half',
    'input-wrap--third': size === 'third'
  })

  const resizeClassNames = classNames({
    'resize--none': resize === 'none',
    'resize--vertical': resize === 'vertical',
    'resize--horizontal': resize === 'horizontal'
  })

  return (
    <div className={wrapClassNames}>
      <Label required={required}>{label}</Label>
      <textarea
        className={resizeClassNames}
        value={getValue(name) ?? ''}
        placeholder={placeholder}
        required={required}
        onChange={handleOnChange}
      />
    </div>
  )
}

TextareaInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  type: PropTypes.string,
  size: PropTypes.oneOf(['half', 'third']),
  resize: PropTypes.oneOf(['none', 'vertical', 'horizontal']),
}